import * as React from 'react'

function SvgSingleDamageIcon(props) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm8 7a7 7 0 1 1 0-14 7 7 0 0 1 0 14Z"
        fill="#E91630"
      />
      <path
        d="M11.036 11.024V8h1.68v3.024l-.24 2.088h-1.2l-.24-2.088ZM11 15.68v-1.704h1.764v1.704H11Z"
        fill="#E91630"
      />
    </svg>
  )
}

export default SvgSingleDamageIcon
